module.exports = __webpack_public_path__ + "static/media/iicc-logo-new.75e8d2ab.png";